import { useCallback } from 'react'
import { harvestFarm } from 'utils/calls'
import { BIG_ZERO } from 'utils/bigNumber'
import getGasPrice from 'utils/getGasPrice'
import { useMasterchef, useSousChef } from 'hooks/useContract'
import { DEFAULT_GAS_LIMIT } from 'config'
import BigNumber from 'bignumber.js'
import { usePool } from 'state/pools/hooks'

const options = {
  gasLimit: DEFAULT_GAS_LIMIT,
}

const harvestPool = async (sousChefContract) => {
  const gasPrice = getGasPrice()
  // options.gasLimit = 700000
  return sousChefContract.deposit('0', { gasPrice })
}

const harvestNewPool = async (sousChefContract, pool?: any) => {
  const gasPrice = getGasPrice()
  const fee =
    pool?.withdrawFee && !pool?.withdrawFeeIsZero
      ? new BigNumber((await sousChefContract.getWithdrawFee()).toString())
          .times(1.02)
          .integerValue(BigNumber.ROUND_DOWN)
          .toString()
      : undefined

  const estimate = Number(
    ((await sousChefContract.estimateGas.withdraw('0', { ...(fee ? { value: fee } : {}) })) * 1.1).toFixed(0),
  )

  return sousChefContract.withdraw('0', {
    ...(fee ? { value: fee } : {}),
    gasPrice,
    gasLimit: estimate,
  })
}

const harvestWithdrawPerNFT = async (sousChefContract, pool?: any, amount?: string) => {
  const mintNFTs = Math.floor(Number(amount) / 10 ** 18)
  const gasPrice = getGasPrice()
  const fee =
    pool?.withdrawFee && !pool?.withdrawFeeIsZero
      ? new BigNumber((await sousChefContract.getWithdrawFee()).toString())
          .times(mintNFTs)
          .times(1.02)
          .integerValue(BigNumber.ROUND_DOWN)
          .toString()
      : undefined
  const estimate = Number(
    ((await sousChefContract.estimateGas.withdraw('0', { ...(fee ? { value: fee } : {}) })) * 1.1).toFixed(0),
  )
  return sousChefContract.withdraw('0', {
    ...(fee ? { value: fee } : {}),
    gasPrice,
    gasLimit: estimate,
  })
}

const harvestPoolBnb = async (sousChefContract) => {
  const gasPrice = getGasPrice()
  options.gasLimit = 700000
  return sousChefContract.deposit({ ...options, value: BIG_ZERO, gasPrice })
}

const useHarvestPool = (sousId, isUsingBnb = false) => {
  const sousChefContract = useSousChef(sousId)
  const masterChefContract = useMasterchef()
  const { pool } = usePool(sousId)

  const handleHarvest = useCallback(
    async (amount?: string) => {
      if (sousId === 0) {
        return harvestFarm(masterChefContract, 0)
      }

      if (isUsingBnb) {
        return harvestPoolBnb(sousChefContract)
      }

      if (sousId === 41 || sousId === 42) {
        return harvestWithdrawPerNFT(sousChefContract, pool, amount)
      }

      if (sousId >= 16) {
        return harvestNewPool(sousChefContract, pool)
      }

      return harvestPool(sousChefContract)
    },
    [isUsingBnb, masterChefContract, sousChefContract, sousId],
  )

  return { onReward: handleHarvest }
}

export default useHarvestPool
